import { NavigateFunction } from "react-router";

export type HomeSection = "services" | "contacts";

const HOME_SECTION_ID_MAP: Record<HomeSection, string> = {
  services: "Services",
  contacts: "Contacts",
};

export const parseHomeSectionTag = (tagId: string | null): HomeSection | null => {
  if (tagId === "services" || tagId === "contacts") {
    return tagId;
  }

  return null;
};

export const navigateToHomeSection = (nav: NavigateFunction, section: HomeSection) => {
  nav({ pathname: "/", search: `?tagId=${section}` });
};

export const goToHomeSection = (nav: NavigateFunction, pathname: string, section: HomeSection, isMobile: boolean) => {
  if (pathname === "/") {
    scrollToHomeSection(section, isMobile);
    return;
  }

  navigateToHomeSection(nav, section);
};

export const scrollToHomeSection = (section: HomeSection, isMobile: boolean, behavior: ScrollBehavior = "smooth") => {
  const elementId = HOME_SECTION_ID_MAP[section];
  const element = document.getElementById(elementId);

  if (!element) return false;

  const elementTop = element.getBoundingClientRect().top + window.scrollY;

  let offset = -30;

  if (section === "contacts" && isMobile) {
    offset += 350;
  }

  window.scrollTo({ top: elementTop + offset, behavior });

  return true;
};

type ScrollToHomeSectionWhenReadyOptions = {
  section: HomeSection;
  isMobile: boolean;
  onComplete?: () => void;
  maxWaitMs?: number;
};

export const scrollToHomeSectionWhenReady = ({
  section,
  isMobile,
  onComplete,
  maxWaitMs = 1600,
}: ScrollToHomeSectionWhenReadyOptions) => {
  let frameId = 0;
  const start = Date.now();

  const attemptScroll = () => {
    const didScroll = scrollToHomeSection(section, isMobile);

    if (didScroll) {
      onComplete?.();
      return;
    }

    if (Date.now() - start >= maxWaitMs) {
      return;
    }

    frameId = window.requestAnimationFrame(attemptScroll);
  };

  frameId = window.requestAnimationFrame(attemptScroll);

  return () => {
    if (frameId !== 0) {
      window.cancelAnimationFrame(frameId);
    }
  };
};
